export function PushHotjarEvent(event: string) {
	if ((window as any).hj)
		(window as any).hj("event", event);
}